/**
 * 根据 x y 取角度
 * @param {*} tan
 * @returns
 */
function getTanDeg(tan) {
  var result = Math.atan(tan) / (Math.PI / 180)
  result = Math.round(result)
  return result
}

/**
 * 画波浪线的笔刷
 * @param {*} fabric
 * @param {*} canvas
 * @returns
 */
export default function(fabric, canvas, options = {}) {
  const waveConf = options.waveConf || {}
  return new fabric.DiagramBrush(canvas, {
    getObject(opt, pointer) {
      return null
    },
    renderMove(opt, pointer) {
      const { scale } = options
      const { canvas, originX, originY } = opt
      const { x: pointerX, y: pointerY } = pointer
      // [起始x,起始y,结束x,结束y]
      // const points = [originX, originY, originX + 50, originY + 50]
      const spaceX = Math.abs(pointerX - originX)
      const spaceY = Math.abs(pointerY - originY)
      // Length of the line
      const len = Math.sqrt(Math.pow(spaceX, 2) + Math.pow(spaceY, 2))
      // Generated points array
      const polyPoints = []
      // 控制波浪线的形状
      // Basic scale factor is a scale factor for the provided "waving" function
      // 控制波的长度， 约小约长
      const basicScaleFactorX = 0.07 / scale
      // Scaling factor for y axis
      // 控制波的高度
      const scaleFactorY = 0.6
      const period = Math.PI * 2

      /*
      * Calculate period rescale factor
      * This is additional factor for scalling X that ensures we have only full periods in the line length
      */
      let periodRescaleFactor = period / basicScaleFactorX * Math.floor(len / (period / basicScaleFactorX)) / len
      if (periodRescaleFactor === undefined || periodRescaleFactor < 0.001) {
        periodRescaleFactor = 1
      }
      // Calulate final x scale factor
      const scaleFactorX = basicScaleFactorX * periodRescaleFactor
      const _funct_ = function(x) {
        return Math.sin(x) * 10
      }
      // Generate poins:
      //  from [-len/2, 0] up to [len/2, 0]
      var step = 1
      for (var x = 0; x < len - step; x += step) {
        polyPoints.push({
          x: x - len / 2,
          y: _funct_(x * scaleFactorX) * scaleFactorY
        })
      }
      const linePoints = []
      // Add new one
      for (var i = 1; i < polyPoints.length; ++i) {
        linePoints.push({
          x: polyPoints[i - 1].x,
          y: polyPoints[i - 1].y
        })
        linePoints.push({
          x: polyPoints[i].x,
          y: polyPoints[i].y
        })
      }
      if (opt.curObject) {
        // 删除老的，重新渲染
        canvas.remove(opt.curObject)
      }
      // 计算角度
      /**
       *      ｜
       *      ｜
       * ——————————————
       *      ｜ 从这里开始算角度，顺时针
       *      ｜
       */
      let angle = 0
      // 右下角
      if (originX < pointerX && originY < pointerY) {
        angle = getTanDeg(spaceY / spaceX)
      }
      // 左下角
      if (originX > pointerX && originY < pointerY) {
        angle = 90 + getTanDeg(spaceX / spaceY)
      }
      // 左上角
      if (originX > pointerX && originY > pointerY) {
        angle = 180 + getTanDeg(spaceY / spaceX)
      }
      // 右上角
      if (originX < pointerX && originY > pointerY) {
        angle = 270 + getTanDeg(spaceX / spaceY)
      }

      // 四个方向的线
      // 右
      if (originX < pointerX && originY === pointerY) {
        angle = 0
      }
      // 左
      if (originX > pointerX && originY === pointerY) {
        angle = 180
      }
      // 下
      if (originX === pointerX && originY < pointerY) {
        angle = 90
      }
      // 上
      if (originX === pointerX && originY < pointerY) {
        angle = 270
      }

      const curObject = new fabric.Polyline(linePoints, {
        name: options.name,
        left: originX,
        top: originY,
        fill: '',
        stroke: 'red',
        // 旋转角度
        angle,
        ...waveConf
      })
      opt.curObject = curObject
      canvas.add(curObject)
      canvas.renderAll()
    },
    // 鼠标起来
    afterMouseUp(brush) {
      // 鼠标起来后将当前物件置空，以防鼠标移动过程中将画好的线删除了
      brush.curObject = null
    }
  })
}